import { render, staticRenderFns } from "./InquiryView.vue?vue&type=template&id=00752b21&"
import script from "./InquiryView.vue?vue&type=script&lang=js&"
export * from "./InquiryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports